import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import Navbar from './Navbar';
import RefundPolicySection from './RefundPolicySection';
import './RefundPolicy.css';

function RefundPolicy() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="refund-page">
      <Navbar />
      <button className="back-button" onClick={() => navigate('/')} aria-label="Go back to home">
        <FaArrowLeft /> Back
      </button>
      
      <div className="refund-page-content">
        <RefundPolicySection />
      </div>
    </div>
  );
}

export default RefundPolicy;